// hooks/use-business-accounts.ts
import { FormEvent, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetBusinessAccounts } from '../../../apis/bussiness-accounts/get-bussiness-accounts';
import { useGetAllStates } from '../../../apis/users/get-all-states';
import { formatDate, isOneDatePresent, areBothDatesPresent } from '../../../utils/helpers';

const useBusinessAccounts = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [zoomed, setZoomed] = useState(false);
    const [image, setImage] = useState("");
    const [key, setKey] = useState(0);

    const filterFormRef = useRef<HTMLFormElement>(null);
    const searchFormRef = useRef<HTMLFormElement>(null);

    const getParam = (key: string) => searchParams.get(key) || "";

    const search = getParam("search");
    const fromDate = getParam("fromDate");
    const toDate = getParam("toDate");
    const state = getParam("state");

    const { data: businessData, isFetching: loading } = useGetBusinessAccounts({
        page: getParam("page") || 1,
        search,
        fromDate,
        todate: toDate,
        state,
    });

    const { data: statesData, isFetching: isLoadingStates } = useGetAllStates();

    const businessAccounts = businessData?.docs ?? [];
    const totalPages = businessData?.totalPages ?? 0;
    const allStates = statesData?.states ?? [];

    const updateUrlParams = (newParams: Record<string, string>) => {
        const updatedParams = new URLSearchParams(searchParams);
        Object.entries(newParams).forEach(([key, value]) => {
            value ? updatedParams.set(key, value) : updatedParams.delete(key);
        });
        setSearchParams(updatedParams);
    };

    const handleSearch = (e: FormEvent) => {
        e.preventDefault();
        const formData = new FormData(e.target as HTMLFormElement);
        updateUrlParams({ search: formData.get("search") as string, page: "1" });
    };

    const handleFilter = (e: FormEvent) => {
        e.preventDefault();
        const formData = new FormData(e.target as HTMLFormElement);
        const from = formData.get("fromDate") as string;
        const to = formData.get("toDate") as string;
        updateUrlParams({
            fromDate: from ? formatDate(from) : "",
            toDate: to ? formatDate(to) : "",
            state: formData.get("state") as string,
            page: "1",
        });
    };

    const handleResetFilters = () => {
        setSearchParams({});
        setKey((prev) => prev + 1);
        searchFormRef.current?.reset();
    };

    const handleZoomImage = (src: string) => {
        setImage(src);
        setZoomed(true);
    };

    const isAnyFilterApplied = state !== "";
    const isApplyButtonDisabled = isAnyFilterApplied
        ? isOneDatePresent(fromDate, toDate)
        : !areBothDatesPresent(fromDate, toDate);
    const isClearButtonDisabled = !search && !fromDate && !toDate && !state;

    return {
        businessAccounts,
        totalPages,
        loading,
        allStates,
        isLoadingStates,
        zoomed,
        setZoomed,
        image,
        key,
        search,
        fromDate,
        toDate,
        state,
        searchParams,
        filterFormRef,
        searchFormRef,
        updateUrlParams,
        handleSearch,
        handleFilter,
        handleResetFilters,
        handleZoomImage,
        isApplyButtonDisabled,
        isClearButtonDisabled,
    };
};

export default useBusinessAccounts;